module.exports = __webpack_public_path__ + "static/media/home.a99f0663.svg";